import React from 'react';
import { Link } from 'react-router-dom';
import { projects } from '../../utils/projects';
import Feature from "./category/Feature";
import stickers from '../../assets/stickers-01.png'
import branding from '../../assets/branding-01.png'
import illustrate from '../../assets/illustration-01.png'
import websystem from '../../assets/webmobilesys-01.png'
import photography from '../../assets/photography-01.png'
import layout from '../../assets/layout-01.png'

class ProjectPage extends React.Component {
    state = {
        currentCategory: ''
    }
    handleCategory (cat) {
        this.setState({ 
            currentCategory: cat
        })
    }
    render() {
        
        const mappedProject = projects.map((project) => project);
        
        const filteredProjects =  this.state.currentCategory === ''
                                    ? projects
                                    : mappedProject.filter((cat, i) => cat['category'].includes(this.state.currentCategory))

        return(
            <div className="page-container" style={{backgroundColor: ' rgb(254, 250, 250)'}}> 
                <div className="category-container">
                    <ul  className="category-list">
                        <li onClick={() => this.handleCategory('')}>ALL</li>
                        <li onClick={() => this.handleCategory('branding')}>BRANDING</li>
                        <li onClick={() => this.handleCategory('illustrate')}>ILLUSTRATE</li>
                        <li onClick={() => this.handleCategory('layout')}>LAYOUT</li>
                        <li onClick={() => this.handleCategory('photography')}>PHOTOGRAPHY</li>
                        <li onClick={() => this.handleCategory('stickers')}>STICKERS</li>
                        <li onClick={() => this.handleCategory('websystem')}>WEB SYSTEMS</li>
                    </ul>
                </div>
                <div className="project-content">
                {
                    filteredProjects.map((item) =>
                        <div key={item.key} className="project-item">
                            <Link to={item.path}>
                                <img src={item.img} alt={item.key} className="image" />
                            </Link>
                        </div>
                    )
                }
                </div>
            </div>
        );
    }
}

export default ProjectPage;


// WEBPACK FOOTER //
// ./src/components/pages/ProjectPage.js